import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BreadcrumbItem as CoreBreadcrumbItem } from '@vds-core/breadcrumbs';
import { calculateRem } from '@vds/utilities';
import { ColorTokens } from '@vds-tokens/color';
import { LayoutTokens } from '@vds-tokens/layout';
var propTypes = {
  /*
   * A prop that will invert the colors of the breadcrumbs for use on dark backgrounds.
   *
   */
  surface: PropTypes.oneOf(['light', 'dark']),

  /**
   * If selected = false on last breadcrumb it will not render with selected styles
   */
  selected: PropTypes.bool
};
var defaultProps = {
  surface: 'light'
};
var SlashWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "VDS__sc-jqirm-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-right: ", ";\n  padding-left: ", ";\n  display: flex;\n  align-items: center;\n  outline: none;\n"])), calculateRem(LayoutTokens.space['1X'].value), calculateRem(LayoutTokens.space['1X'].value));
var StyledSlash = /*#__PURE__*/styled.span.withConfig({
  componentId: "VDS__sc-jqirm-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var color = _ref.color;
  return color;
});

var BreadcrumbItem = function BreadcrumbItem(props) {
  var surface = props.surface;

  var renderIcon = function renderIcon() {
    var color = surface === 'dark' ? ColorTokens.elements.primary.ondark.value : ColorTokens.elements.primary.onlight.value;
    return /*#__PURE__*/React.createElement(SlashWrapper, {
      "aria-hidden": true,
      tabIndex: -1
    }, /*#__PURE__*/React.createElement(StyledSlash, {
      "aria-hidden": true,
      tabIndex: -1,
      color: color
    }, "/"));
  };

  return /*#__PURE__*/React.createElement(CoreBreadcrumbItem, _extends({}, props, {
    hoverState: true,
    renderSeparator: renderIcon,
    focusRingBorderRadius: "2px"
  }));
};

BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;
export default BreadcrumbItem;